import { useCart } from "../contexts/CartContext";
import { ProductImage } from "./ProductImage";

export function QuickAddCard({ p }) {
  const { add } = useCart();
  const disabled = !!p.coming_soon;
  return (
    <div className="bg-[#FDF4E3] border border-[#E5D8C1] p-4 flex flex-col items-center text-center" data-testid={`quickadd-${p.id}`}>
      <div className="w-24 h-24 relative">
        <ProductImage p={p} />
      </div>
      <div className="font-heading text-sm uppercase tracking-wide mt-3 leading-tight">{p.name}</div>
      <div className="text-xs text-[#5C5A56] mt-1">${p.case_price.toFixed(2)} / case</div>
      <button
        disabled={disabled}
        onClick={() => !disabled && add(p.id, 1)}
        className="mt-3 w-full bg-[#1A1A1A] text-white hover:bg-[#D32F2F] py-2 text-xs uppercase tracking-widest disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`quickadd-btn-${p.id}`}
      >
        {disabled ? "Coming soon" : "Add case"}
      </button>
    </div>
  );
}
